import { useEffect, useState } from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import logo from '../../assets/logo.png';
import api from '../../Components/Api/Api3';
import apiTx from '../../Components/Api/Api';
import Spinner from '../../Components/Spinner';
import { useSearchParams } from "react-router-dom";
import './index.scss';
import { Console } from "console";
const Painelindicadores = () => {
    const [searchParams] = useSearchParams();     
    const [filial, setFilial] = useState<any>(searchParams.get('filial') || '');
    const [atendentes, setAtendentes] = useState<any[]>([])
    const [ShowLoading, setShowLoading] = useState(false) 
    const [ocupaoficina, setOcupaoficina] = useState<any[]>([])
    const [ocupaobalanc, setOcupaobalanc] = useState<any[]>([])
    const [todos, setTodos] = useState<any[]>([])
    const [mecanica, setMecanico] = useState<any[]>([])
    const [balanceamento, setBalanceamento] = useState<any[]>([])
    const [alinhamento, setAlinhamento] = useState<any[]>([])
    const [dtini, setDtini] = useState('')
    const [showpainel, setShowpainel] = useState(false)
    const [showpin, setShowpin] = useState(false)
    const [pin, setPin] = useState('')
    const [gpin, setGpin] = useState('')
    const credentials = btoa("RestAPI:siga@181"); 
    const headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        "Accept": "application/json",
        'Authorization': `Basic ${credentials}`
    }
    const isFilial01 = (valor?: any) => {
        const filialInformada = String(valor ?? filial ?? '').trim();
        return filialInformada === '01' || filialInformada === '1';
    };
    const getApiPorFilial = (valor?: any) => (isFilial01(valor) ? apiTx : api);
    const garantirArray = (valor: any) => (Array.isArray(valor) ? valor : []);
    const tratarErroApi = (erro: any, origem: string) => {
        console.error(`Erro de rede (${origem}):`, erro);
        setShowLoading(false);
    }

    const obterFilialValida = (valor?: any) => {
        const filialInformada = String(valor ?? filial ?? '').trim();
        if (!filialInformada) {
            alert('Filial não informada na URL. Use ?filial=XX');
            return null;
        }
        return filialInformada;
    }
    //const diaSemanaAtual = new Date().getDay();
    function getPin (cFilial: any) {
        const filialValida = obterFilialValida(cFilial);
        if (!filialValida) return;

        setTimeout(() => {
        setShowLoading(true)    
        getApiPorFilial(filialValida).get('Getpin?filial='+filialValida,{headers})
        .then(response => {
            if (response.data.Pin.length > 0 ){  
                setGpin(response.data.Pin[0]["PIN"]) // MV_PINCARC               
                setShowLoading(false)
                if(pin === response.data.Pin[0]["PIN"]){
                    setShowpainel(true);
                    setShowpin(true)
                    setShowLoading(false)
                }else{
                    alert('Pin invalido!')
                    setShowLoading(false)
                }                  
                  //setInfoveuculo('Placa: ' + placa + ' Modelo: ' + response.data.Dadosveiculo[0]['modelo'] + ' Cor: ' + response.data.Dadosveiculo[0]['cor'])                     
            }else{
                  //setInfoveuculo('Placa não cadastrada!')
                setShowLoading(false)
            }                                   
        })
        .catch((erro) => tratarErroApi(erro, 'Getpin'));
        }, 10 );        
    };    
    function getAtendentes (cFilial: any) {
        const filialValida = obterFilialValida(cFilial);
        if (!filialValida) return;

        setTimeout(() => {
        setShowLoading(true)
        getApiPorFilial(filialValida).get('Produtividade?filial='+filialValida+'&page=0&perpage=15&dtini='+dtini,{headers})
        .then(response => {
            const listaAtendentes = garantirArray(response?.data?.Atendentes);
            if (listaAtendentes.length > 0 ){  
                setAtendentes(listaAtendentes)                
                setShowLoading(false)  
                  //setInfoveuculo('Placa: ' + placa + ' Modelo: ' + response.data.Dadosveiculo[0]['modelo'] + ' Cor: ' + response.data.Dadosveiculo[0]['cor'])                     
            }else{
                setAtendentes([])
                  //setInfoveuculo('Placa não cadastrada!')
                setShowLoading(false)
            }                                   
        })
        .catch((erro) => tratarErroApi(erro, 'Produtividade'));
        }, 10 );        
    };
    const oficina = (tp: string) => {
        const filialValida = obterFilialValida();
        if (!filialValida) return;

        setTimeout(() => {
            setShowLoading(true)
            getApiPorFilial(filialValida).get('Ocupacaooficina?filial='+filialValida+'&tp='+tp+'&dtini='+dtini,{headers})
            .then(response => {
                const dadosOcupaoficina = garantirArray(response?.data?.Ocupaoficina);
                if (dadosOcupaoficina.length > 0 ){         
                    if(tp === '1'){
                        setOcupaoficina(dadosOcupaoficina)  
                        if (dadosOcupaoficina.length < 21)
                            for (let index = dadosOcupaoficina.length + 1; index <= 21; index++) { 
                                setOcupaoficina(prev => prev.concat(index))
                            }                        
                    }else{                        
                        setOcupaobalanc(dadosOcupaoficina)
                        if (dadosOcupaoficina.length < 42)
                            for (let index = dadosOcupaoficina.length + 1; index <= 42; index++) { 
                                setOcupaobalanc(prev => prev.concat(index))
                            }
                    }
                    setShowLoading(false)                                         
                }else{
                    setShowLoading(false)
                    if(ocupaoficina.length === 0){
                        if (dadosOcupaoficina.length < 21)
                            for (let index = dadosOcupaoficina.length + 1; index <= 21; index++) { 
                                setOcupaoficina(prev => prev.concat(index))
                            }                    
                    }
                }                                   
            })
            .catch((erro) => tratarErroApi(erro, 'Ocupacaooficina'));
            }, 10 );         
    }
    const comparativos = () => {
        const filialValida = obterFilialValida();
        if (!filialValida) return;

        setTimeout(() => {
            setShowLoading(true)
            getApiPorFilial(filialValida).get('Comparativos?filial='+filialValida+'&dtini='+dtini,{headers})
            .then(response => {
                    const comparativo = response?.data?.Comparativos || {};
                    setMecanico(garantirArray(comparativo["MECANICA"]))   
                    setBalanceamento(garantirArray(comparativo["BALANCEAMENTO"]))     
                    setAlinhamento(garantirArray(comparativo["ALINNHAMENTO"]))                                                     
                    setShowLoading(false)                                   
            })
            .catch((erro) => tratarErroApi(erro, 'Comparativos'));
            }, 10 );         
    }   

    const atualizar = () => {
        getAtendentes (filial);
        setOcupaoficina([])
        setOcupaobalanc([])
        setMecanico([])
        setBalanceamento([])
        setAlinhamento([])
        oficina('1');
        oficina('2');
        comparativos();
    }
    const getdate = (el: any) => {
        if(el.target.id === 'data1' && el.target.value !== ''){
          setDtini(el.target.value.split('-').join(''))
        // }else if (el.target.id === 'data2' && el.target.value !== ''){ 
        //   setDtfim(el.target.value.split('-').join(''))
         }else{
            setDtini('')
         }
      }  
    useEffect(() => {
        setFilial(searchParams.get('filial') || '');
    }, [searchParams]);

    useEffect(() => {
        const painel = document.querySelectorAll("div[id=divpainel]");  
        if (showpainel === true){
            painel[0].setAttribute('style', 'display:block');
        }else{
            painel[0].setAttribute('style', 'display:none');
        } 
        const pin = document.querySelectorAll("div[id=divpin]");  
        if (showpin === false){
            pin[0].setAttribute('style', 'display:block');
        }else{
            pin[0].setAttribute('style', 'display:none');
        }               
    });         
    return (
        <>
        <div id="divpin" className="mt-4 ms-4">
            <label className="me-2">Digite o Pin</label>
            <input className="me-4" onChange={(e) => {setPin(e.target.value)}}></input>
            <button onClick={() => getPin(filial)}>Entrar</button>
        </div>
        <div id="divpainel">            
            <Row className="flex-collum1">
                <Col className='w-25 d-flex justify-content-center'>
                    <img
                        src={logo}
                        className="logo"
                        alt="Car Center Pneus Brasil"
                        />                     
                </Col>
                <Col className='w-75 d-flex justify-content-start coll1-descri'>
                    <span className="fs-1 text-white font-weight-bold">Painel Indicadores</span>                    
                </Col>
            </Row> 
            {/* <Container> */}
            <Row>
                <Col>
                    <Row>
                        <Col className="mt-2 mb-2 d-flex justify-content-end">
                            <input type="date" className="input-group-text" id='data1' onBlur={(e) => getdate(e)}></input>
                        </Col>
                        <Col className="mt-2 mb-2">
                            <button className="ms-4 btn btn-success" onClick={() => {atualizar()}}>Atualizar</button>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row className="view-port">    
                <Col className="border border-dark view-port1">
                    <Row className="bg-secondary text-white title">
                        <Col className="d-flex justify-content-center">
                            <span>Produtividade</span>                                            
                        </Col>                               
                    </Row>                    
                    <Row>
                        <Col>
                            <Table striped bordered hover variant="light" responsive className='scrol'>
                                <thead>
                                    <tr className='col-title'>      
                                    <th>Atendente</th>
                                    <th>Hr Trab.</th>
                                    <th>Hr Pard.</th>
                                    </tr>
                                </thead> 
                                <tbody className=''> 
                                    {atendentes.map((list: any, index: number) => (           
                                        <tr key={list?.id ?? `atd-${index}`}>
                                        <td className="tdcurto">{list.atendente}</td>
                                        <td className="tdcurto">{list.horatb}</td>  
                                        <td className="tdcurto">{list.horapr}</td>                                
                                        </tr>
                                    ))}                        
                                </tbody>
                            </Table> 
                        </Col>                                        
                    </Row>
                </Col>

                {/* Eficiência */}
                <Col className="border border-dark view-port2">
                    <Row className="bg-secondary text-white title">
                        <Col className="d-flex justify-content-center">
                            <span>Serviço Mecanico</span>                                            
                        </Col>                               
                    </Row>                     
                    {mecanica.map((m: any, index: number) => ( 
                        <div key={m?.id ?? `mec-${index}`} className="bg-info text-dark border border-dark d-flex justify-content-center">
                        <ul>
                            <li>{m.atendente}</li>
                            <li><strong>Qt:</strong> <span className="text-dark">{m.quantidade}</span> <strong>Hr:</strong> <span className="text-dark">{m.tempo}</span> <strong>Media:</strong> <span className="text-dark">{m.media}</span></li>
                        </ul>
                        </div>            
                    ))}                     
                </Col>
                <Col className="border border-dark view-port2">
                    <Row className="bg-secondary text-white title">
                        <Col className="d-flex justify-content-center">
                            <span>Serviço Balanceamento</span>                                            
                        </Col>                               
                    </Row>                     
                    {balanceamento.map((b: any, index: number) => (  
                        <div key={b?.id ?? `bal-${index}`} className="bg-success text-white border border-dark d-flex justify-content-center">
                            <ul>
                            <li>{b.atendente}</li>
                            <li><strong>Qt:</strong> <span className="text-warning">{b.quantidade}</span> <strong>Hr:</strong> <span className="text-warning">{b.tempo}</span> <strong>Media:</strong> <span className="text-warning">{b.media}</span></li>
                            </ul>
                        </div>
                                    
                                ))} 
                </Col>  
                <Col className="border border-dark view-port2">
                <Row className="bg-secondary text-white title">
                        <Col className="d-flex justify-content-center">
                            <span>Serviço Alinhamento</span>                                            
                        </Col>                               
                    </Row>                     
                    {alinhamento.map((a: any, index: number) => (  
                        <div key={a?.id ?? `ali-${index}`} className="bg-danger text-white border border-dark d-flex justify-content-center">
                            <ul>
                            <li>{a.atendente}</li>
                            <li><strong>Qt:</strong> <span className="text-warning">{a.quantidade}</span> <strong>Hr:</strong> <span className="text-warning">{a.tempo}</span> <strong>Media:</strong> <span className="text-warning">{a.media}</span></li>
                            </ul>
                        </div>
                                    
                                ))} 
                </Col>                  
                <Col className="border border-dark view-port4">
                    <Row className="mb-4">
                        <Col>
                            <Row className="bg-secondary text-white title">
                                <Col className="d-flex justify-content-center">
                                    <span>Ocupação Balaceamento/Alinha</span>                                            
                                </Col>                               
                            </Row>
                            <div className="d-flex align-content-stretch flex-wrap"> 
                                {ocupaobalanc.map((list: any, index: number) => {
                                    const itemKey = list?.id ?? `obal-${index}`;
                                    if (list?.cor === 'verde') {
                                        return <div key={itemKey} className="bg-success text-white ocupaoficina border border-dark d-flex justify-content-center">{list?.percentual ?? 0}</div>;
                                    }
                                    if (list?.cor === 'amarelo') {
                                        return <div key={itemKey} className="bg-warning text-dark ocupaoficina border border-dark d-flex justify-content-center">{list?.percentual ?? 0}</div>;
                                    }
                                    if (list?.cor === 'vermelho') {
                                        return <div key={itemKey} className="bg-warning text-dark ocupaoficina border border-dark d-flex justify-content-center">{list?.percentual ?? 0}</div>;
                                    }
                                    return <div key={itemKey} className="bg-light text-white ocupaoficina border border-dark d-flex justify-content-center">0</div>;
                                })}                         
                            </div>                
                        </Col> 
                    </Row>
                    <Row>
                        <Col>
                            <Row className="bg-secondary text-white title">
                                <Col className="d-flex justify-content-center">
                                    <span>Ocupação Oficina</span>                                            
                                </Col>                               
                            </Row>
                            <div className="d-flex align-content-stretch flex-wrap"> 
                                {ocupaoficina.map((list: any, index: number) => {
                                    const itemKey = list?.id ?? `ofi-${index}`;
                                    if (list?.cor === 'verde') {
                                        return <div key={itemKey} className="bg-success text-white ocupaoficina border border-dark d-flex justify-content-center">{list?.percentual ?? 0}</div>;
                                    }
                                    if (list?.cor === 'amarelo') {
                                        return <div key={itemKey} className="bg-warning text-dark ocupaoficina border border-dark d-flex justify-content-center">{list?.percentual ?? 0}</div>;
                                    }
                                    if (list?.cor === 'vermelho') {
                                        return <div key={itemKey} className="bg-warning text-dark ocupaoficina border border-dark d-flex justify-content-center">{list?.percentual ?? 0}</div>;
                                    }
                                    return <div key={itemKey} className="bg-light text-white ocupaoficina border border-dark d-flex justify-content-center">0</div>;
                                })}                         
                            </div>                
                        </Col> 
                    </Row>                   
                </Col>                
            </Row>
            
        </div>
            {/* </Container>             */}
            <Spinner isLoading={ShowLoading} />
        </>
    )
};

export default Painelindicadores;
